export default __webpack_public_path__ + "49285cb174ba65d1a1cd43824f30a4b5.ico";